var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("CorporateNavigation", { attrs: { ActivePage: "resources" } }),
      _vm._v(" "),
      _vm.rm
        ? _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-lg-6" }, [
                  _c("h6", [
                    _c(
                      "a",
                      {
                        directives: [
                          {
                            name: "sanitizedHref",
                            rawName: "v-sanitizedHref",
                            value: `/#/enterprise/resources/${_vm.workspaceId}/${_vm.strategyId}`,
                            expression:
                              "`/#/enterprise/resources/${workspaceId}/${strategyId}`",
                          },
                        ],
                        staticClass: "text-dark",
                      },
                      [
                        _c("i", {
                          staticClass: "fa fa-angle-double-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" Back to resources\n                    "),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "h1",
                    {
                      staticStyle: {
                        "font-size": "2em",
                        "font-weight": "300",
                        color: "#33475b",
                        margin: "0",
                      },
                    },
                    [_vm._v(_vm._s(_vm.rm.ResourceName))]
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _vm.isEditing
                      ? _c("SaveButton", {
                          attrs: { savingState: _vm.savingState },
                          on: {
                            saveChanges: function ($event) {
                              return _vm.handleSaveCommand()
                            },
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isEditing
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-outline-secondary",
                            staticStyle: { padding: "0.7em 2em" },
                            on: { click: _vm.cancelEditing },
                          },
                          [_vm._v(_vm._s(_vm.stopEditingLabel))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isEditing
                      ? _c(
                          "button",
                          {
                            staticClass: "btn btn-success",
                            staticStyle: { padding: "0.7em 2em" },
                            on: { click: _vm.startEditing },
                          },
                          [_vm._v("Edit capacity")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 60px" },
              }),
              _vm._v(" "),
              _vm.isEditing
                ? _c(
                    "div",
                    [
                      _c(
                        "div",
                        {
                          staticClass: "alert alert-warning",
                          attrs: { role: "alert" },
                        },
                        [
                          _vm._v(
                            "\n                Warning: Formula entered here will save as values.\n            "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("EditableValueSeriesSheet", {
                        ref: "sheet",
                        attrs: {
                          propTitle: _vm.title,
                          propSeries: _vm.inputSeries,
                          propColumns: _vm.columns,
                        },
                        on: { dataChange: _vm.onDataChange },
                      }),
                    ],
                    1
                  )
                : _c("div", [
                    _c(
                      "table",
                      {
                        staticClass:
                          "table table-bordered table-hover text-center",
                      },
                      [
                        _vm._m(0),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.rm.Years, function (y) {
                            return _c(
                              "tr",
                              { key: y.Year },
                              [
                                _c("td", { staticClass: "align-middle" }, [
                                  _vm._v(_vm._s(y.Year)),
                                ]),
                                _vm._v(" "),
                                _vm._l(12, function (i) {
                                  return _c(
                                    "td",
                                    { staticClass: "align-middle" },
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(y.Values[i - 1]) +
                                          "\n                        "
                                      ),
                                    ]
                                  )
                                }),
                              ],
                              2
                            )
                          }),
                          0
                        ),
                      ]
                    ),
                  ]),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", { staticClass: "align-middle", attrs: { rowspan: "2" } }, [
          _vm._v("Year"),
        ]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle", attrs: { colspan: "12" } }, [
          _vm._v("Months"),
        ]),
      ]),
      _vm._v(" "),
      _c("tr", [
        _c("th", { staticClass: "align-middle" }, [_vm._v("1")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle" }, [_vm._v("2")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle" }, [_vm._v("3")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle" }, [_vm._v("4")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle" }, [_vm._v("5")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle" }, [_vm._v("6")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle" }, [_vm._v("7")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle" }, [_vm._v("8")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle" }, [_vm._v("9")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle" }, [_vm._v("10")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle" }, [_vm._v("11")]),
        _vm._v(" "),
        _c("th", { staticClass: "align-middle" }, [_vm._v("12")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }